import { Controller } from "@hotwired/stimulus"

export function resetActionLoadingState(element, spinner) {
  element.setAttribute("aria-busy", "false")
  element.setAttribute("aria-disabled", "false")
  spinner.classList.add("hidden")
}

export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.reset = this.reset.bind(this)
    document.addEventListener("turbo:before-cache", this.reset)
    window.addEventListener("pageshow", this.reset)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset)
    window.removeEventListener("pageshow", this.reset)
  }

  start(event) {
    if (this.element.getAttribute("aria-busy") === "true") {
      event.preventDefault()
      return
    }

    this.element.setAttribute("aria-busy", "true")
    this.element.setAttribute("aria-disabled", "true")
    this.spinnerTarget.classList.remove("hidden")
  }

  reset() {
    resetActionLoadingState(this.element, this.spinnerTarget)
  }
}
